import { DropDownList } from '@progress/kendo-react-dropdowns'
import { FieldRenderProps, FieldWrapper } from '@progress/kendo-react-form';
import React, { FunctionComponent } from 'react'
import { IProject } from '../../../types/Project/IProject'
import {
  Label,
  Error,
  Hint,
} from "@progress/kendo-react-labels";
import { toDigital } from '../../../utils/utils';
import { ProjectApi } from '../../../redux/api/ProjectApi';
const ProjectList: FunctionComponent<FieldRenderProps> = props => {
  const { data: projects, isLoading: projectLoading } = ProjectApi.useGetProjectListQuery(props.companyId);
  const {
    validationMessage,
    label,
    id,
    disabled,
    optional,
    selectedProject,
  } = props;
  const isValid = !validationMessage;
  const showValidationMessage = validationMessage;
  const showHint = selectedProject && !(selectedProject as IProject)?.Unlimited_Ret;
  const availableTime = (selectedProject as IProject)?.Available_Time;
  const hintId = showHint ? `${id}_hint` : "";
  const errorId = showValidationMessage ? `${id}_error` : "";
  const defaultValue = { ID: 0, Project_Name: "Select" } as IProject
  const sortedProjects = [...projects || []].sort((a, b) => a.Project_Name.localeCompare(b.Project_Name));
  return (
    <FieldWrapper>
      <Label
        editorId={id}
        editorValid={isValid}
        editorDisabled={disabled}
        optional={optional}
      >
        {label} {showValidationMessage && (<Error id={errorId}>{validationMessage}</Error>)}
      </Label>

      <div className={"k-form-field-wrap"} >
        {/* selectedProject:{selectedProject?.Project_Name} */}
        <DropDownList valid={isValid} defaultItem={defaultValue} popupSettings={{ className: 'z500' }} onChange={(e) => props.onSelect(e.value)} value={selectedProject} data={sortedProjects} dataItemKey="ID" textField="Project_Name" loading={projectLoading} required={true} />
        {showHint && <Hint id={hintId}>
          <span className={availableTime > 0 ? 'k-text-success' : 'k-text-error'}>{label} time remaining: {toDigital((selectedProject as IProject)?.Available_Time, true)}</span>
        </Hint>}

      </div>
    </FieldWrapper>
  )
}


export default ProjectList;